import { LeafletEvent } from "leaflet";
import { useMapEvent } from "react-leaflet";
import { ClickProps, ZoomProps } from "./types";

export function EventClick({ onClick }: ClickProps)
{
    useMapEvent('click', (e) =>
    {
        //Hinweis: [lat, lng] = [y, x]
        if (onClick) onClick({ y: e.latlng.lng, x: e.latlng.lat });
    });

    return null;
}

export function EventZoom({ onZoom }: ZoomProps)
{
    useMapEvent('zoomend', (e: LeafletEvent) =>
    {
        if (onZoom) onZoom(e);
    });

    return null;
} 